import "../styles/brands.css";
import "animate.css";
import { useInView } from "react-intersection-observer";
import Tooltip from "./tooltip";
function Brands({ t, openModal }) {
  const [ref, inView] = useInView({ threshold: 0.4 });

  return (
    <section
      ref={ref}
      className="u-align-center u-clearfix u-section-2"
      id="Dirigido"
    >
      <div className="u-align-left u-clearfix u-sheet u-valign-middle u-sheet-1">
        <h2 className="u-align-center u-text u-text-default u-text-palette-2-base u-text-1">
          {t("seccion2_1")}
        </h2>
        <div className="u-expanded-width u-list u-list-1">
          <div className="u-repeater u-repeater-1">
            <div className="u-container-style u-list-item u-repeater-item">
              <div className="u-container-layout u-similar-container u-container-layout-1">
                <div className="u-hover-feature u-icon u-icon-circle u-icon-1">
                  <img
                    width={80}
                    height={80}
                    src="images/especializadas.svg"
                    alt="logo-2"
                  />
                </div>
                <h3
                  className="u-align-center u-text u-text-default u-text-palette-2-base u-text-5"
                  data-animation-name="customAnimationIn"
                  data-animation-duration="1000"
                >
                  {t("seccion2_2")}
                </h3>
                <p className="u-align-center u-text u-text-palette-2-base u-text-3">
                  {" "}
                  {t("seccion2_3")}
                  <br />
                </p>
                <h4 className="u-align-center u-text u-text-palette-2-base u-text-4"></h4>
              </div>
            </div>
            <div className="u-align-center u-container-style u-list-item u-repeater-item">
              <div className="u-container-layout u-similar-container u-container-layout-2">
                <div className="u-hover-feature u-icon u-icon-circle u-icon-2">
                  <img
                    width={80}
                    height={80}
                    src="images/cpgc.svg"
                    alt="logo-1"
                  />
                </div>
                <h3
                  className="u-align-center u-text u-text-default u-text-palette-2-base u-text-5"
                  data-animation-name="customAnimationIn"
                  data-animation-duration="1000"
                >
                  {t("seccion2_4")}
                </h3>
                <p className="u-align-center u-text u-text-palette-2-base u-text-6">
                  {" "}
                  {t("seccion2_5")}
                  <br />
                </p>
                <h4 className="u-align-center u-text u-text-palette-2-base u-text-4">
                  {" "}
                  {t("seccion2_6")}
                </h4>
              </div>
            </div>
          </div>
        </div>

        <Tooltip text={t("tooltip_1")} position="top">
          <span
            onClick={() => openModal(t("button_1"))}
            className="u-align-center u-border-none u-btn u-btn-round u-button-style u-hover-palette-1-light-1 u-palette-2-base u-radius-50 u-btn-1"
          >
            {" "}
            {t("button_1")}
          </span>
        </Tooltip>
        <Tooltip text={t("tooltip_1")} position="top">
          <span
            onClick={() => openModal(t("button_5"))}
            className="u-align-center u-border-none u-btn u-btn-round u-button-style u-hover-palette-1-light-1 u-palette-2-base u-radius-50 u-btn-1"
          >
            {" "}
            {t("button_5")}
          </span>
        </Tooltip>
      </div>
    </section>
  );
}

export default Brands;
